export const NOT_PRESENT = 'NOT_PRESENT';
export const UNKNOWN = 'unknown';

export const STATUS_CODE_1XX = '1xx';
export const STATUS_CODE_3XX = '3xx';
export const STATUS_CODE_4XX = '4xx';
export const STATUS_CODE_5XX = '5xx';
